import { Coupon } from 'src/models/Coupon';
import { SubscriptionProduct } from 'src/models/SubscriptionProduct';
import { calculateDiscountedPrice } from 'src/models/SubscriptionProductPriceDetails';

export const isPaymentMethodRequired = (product: SubscriptionProduct, coupon: Coupon | null): boolean => {
  const { isRenewable } = product;
  //TODO: this should be a database logic
  const couponAppliesTo =
    coupon == null
      ? false
      : coupon.appliesTo.length === 0 ||
        coupon.appliesTo.includes(product.id) ||
        coupon?.subscriptionProduct === product.id;
  const isFirstPaymentFree =
    couponAppliesTo && calculateDiscountedPrice(product, coupon!) === 0;
  const notPartnerProduct =
    product.id !== 'f0c28d5e-7545-44b3-a0e8-25d7d1fb83a1';

  return !isFirstPaymentFree || (isRenewable && notPartnerProduct);
};
